
import { DateStrategyAssign } from "app/shared/model/EditPricelist";
import { toIso } from "../date/iso";

export const strategyKey = (ds: DateStrategyAssign): string => {
    const of = toIso(ds.originalFromDate ?? ds.fromDate);
    const ot = toIso(ds.originalToDate ?? ds.toDate ?? null);
    return `${ds.strategyTypeId}|${of}|${ot}`;
};

